<template>
  <div>
    <DivisorComLegenda legenda="Chegada dos produtos antes do inicio do evento" class="mt-3 mb-5"/>

    <v-row class="ma-0">
      <v-col cols="3" class="ma-0">
        <TextFieldFormatadorDeValor
          v-model="config_anterior.dias_evento"
          suffix="dias"
          label="Dia limite"
          outlined
          dense
          hide-details
          ref="text-field-formatador-8"
          class="test-sazonalidade mx-0 d-inline-flex"
          @keyup.enter="aplicarConfiguracaoAntesDoEvento(8)"
        />
      </v-col>

      <v-col cols="ma-0">
        <v-row class="mx-0 mb-2 d-block">
          Se a chegada dos produtos for anterior a {{ config_anterior.dias_evento }} dias antes do evento, a projeção aplicada é
          <TextFieldFormatadorDeValor
            v-model="config_anterior.projecao_evento_anterior"
            suffix="%"
            hide-details
            ref="text-field-formatador-9"
            style="max-width: 60px; margin: 0px 5px;"
            class="test-sazonalidade pa-0 d-inline-flex"
            @keyup.enter="aplicarConfiguracaoAntesDoEvento(9)"
          />
        </v-row>

        <v-row class="mx-0 mt-2 d-block">
          Se a chegada dos produtos for entre {{ config_anterior.dias_evento }} dias antes do evento e o inicio do evento, a projeção aplicada é
          <TextFieldFormatadorDeValor
            v-model="config_anterior.projecao_evento_posterior"
            suffix="%"
            hide-details
            ref="text-field-formatador-10"
            style="max-width: 60px; margin: 0px 5px;"
            class="test-sazonalidade pa-0 d-inline-flex"
            @keyup.enter="aplicarConfiguracaoAntesDoEvento(10)"
          />
        </v-row>
      </v-col>
    </v-row>

    <DivisorComLegenda legenda="Chegada dos produtos durante o evento" class="my-4" />

    <v-data-table
      :items="DESSERTS_COMPUTED"
      :fixed-header="true"
      hide-default-footer
      hide-default-header
      class="table-full-screen elevation-1 mx-0 mb-4 pb-3"
    >
      <template #item="{ item }">
        <p v-if="item.verificador == 'inicio'" class="my-0 mx-2">
          Chegada for
          <TextFieldFormatadorDeValor
            v-model="item.porcentagem_2"
            prefix="<="
            suffix="%"
            class="test-sazonalidade d-inline-flex"
            hide-details
            inteiro
            style="max-width: 60px; margin: 0px 5px;"
            ref="text-field-formatador-1"
            @keyup.enter="aplicarPorcentagem(item, 1)"
          />
          após o início do evento, aplicar
          <TextFieldFormatadorDeValor
            v-model="item.projecao"
            suffix="%"
            class="test-sazonalidade d-inline-flex"
            hide-details
            inteiro
            style="max-width: 60px; margin: 0px 5px;"
            ref="text-field-formatador-2"
            @keyup.enter="aplicarPorcentagem(item, 2)"
          />
          da projeção de vendas calculada
        </p>

        <p v-else-if="item.verificador == 'final'" class="my-0 mx-2">
          Chegada for
          <TextFieldFormatadorDeValor
            v-model="item.porcentagem_1"
            prefix=">"
            suffix="%"
            class="test-sazonalidade d-inline-flex"
            hide-details
            inteiro
            style="max-width: 60px; margin: 0px 5px;"
            ref="text-field-formatador-3"
            @keyup.enter="aplicarPorcentagem(item, 3)"
          />
          após o início do evento, aplicar
          <TextFieldFormatadorDeValor
            v-model="item.projecao"
            suffix="%"
            class="test-sazonalidade d-inline-flex"
            hide-details
            inteiro
            style="max-width: 60px; margin: 0px 5px;"
            ref="text-field-formatador-4"
            @keyup.enter="aplicarPorcentagem(item, 4)"
          />
          da projeção de vendas calculada
        </p>

        <p v-else class="my-0 mx-2">
          Chegada for
          <TextFieldFormatadorDeValor
            v-model="item.porcentagem_1"
            prefix=">"
            suffix="%"
            class="test-sazonalidade d-inline-flex"
            hide-details
            inteiro
            style="max-width: 60px; margin: 0px 5px;"
            ref="text-field-formatador-5"
            @keyup.enter="aplicarPorcentagem(item, 5)"
          />
          e
          <TextFieldFormatadorDeValor
            v-model="item.porcentagem_2"
            prefix="<="
            suffix="%"
            class="test-sazonalidade d-inline-flex"
            hide-details
            inteiro
            style="max-width: 60px; margin: 0px 5px;"
            ref="text-field-formatador-6"
            @keyup.enter="aplicarPorcentagem(item, 6)"
          />
          após o início do evento, aplicar
          <TextFieldFormatadorDeValor
            v-model="item.projecao"
            suffix="%"
            class="test-sazonalidade d-inline-flex"
            hide-details
            inteiro
            style="max-width: 60px; margin: 0px 5px;"
            ref="text-field-formatador-7"
            @keyup.enter="aplicarPorcentagem(item, 7)"
          />
          da projeção de vendas calculada
        </p>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import TextFieldFormatadorDeValor from '@/components/utils/TextFieldFormatadorDeValor.vue';
import Api from '@/api/api';
import Responsividade from '@/helpers/ResponsiveHeight';
import DivisorComLegenda from '@/components/utils/DivisorComLegenda.vue';
import { mapGetters, mapMutations } from 'vuex';

export default {
  mixins: [Responsividade],
  components: {
    TextFieldFormatadorDeValor,
    DivisorComLegenda
  },
  data: () => ({
    desserts: [],
    config_anterior: {},
  }),
  created() {
    this.buscarDados();
  },
  computed: {
    ...mapGetters({
      GET_FORM_NOVO_EVENTO: 'EventoSazonalFinal/GET_FORM_NOVO_EVENTO',
      GET_DIALOG_CONFIGURACAO_GERAL: 'EventoSazonalFinal/GET_DIALOG_CONFIGURACAO_GERAL',
      GET_DIALOG_CONFIGURACAO_INDIVIDUAL: 'EventoSazonalFinal/GET_DIALOG_CONFIGURACAO_INDIVIDUAL',
    }),
    DESSERTS_COMPUTED() {
      return this.desserts.map((m, i) => {
        m.index_of = i;
        return m;
      });
    }
  },
  watch: {
    GET_DIALOG_CONFIGURACAO_GERAL(valor) {
      this.$store.dispatch('EventoSazonalFinal/setFormNovoEvento', {
        id: '',
        nome_evento: '',
        data_inicial: '',
        data_final: '',
        data_inicio_compra: ''
      });

      if(valor) this.buscarDados();
    },
    GET_DIALOG_CONFIGURACAO_INDIVIDUAL(valor) {
      if(valor) this.buscarDados();
    }
  },
  methods: {
    buscarDados() {
      Api.post(`eventos-sazonais/parametrizacao/configuracao`, this.GET_FORM_NOVO_EVENTO)
        .then((response) => {
          const { config_anterior, dados } = response.data;
          this.config_anterior = config_anterior;
          this.desserts = dados;
        })
        .catch(this.Helpers.logout)
    },
    resetBlur(n) {
      const chave = `text-field-formatador-${n}`;
      const rf = this.$refs[chave];
      rf.$children[0].onBlur();
    },
    aplicarPorcentagem(i, evt) {
      this.resetBlur(evt);

      if (i.porcentagem_1 == null) {
        this.desserts[i.index_of + 1].porcentagem_1 = i.porcentagem_2;
      } else if (i.porcentagem_2 == null) {
        this.desserts[i.index_of - 1].porcentagem_2 = i.porcentagem_1;
      } else {
        this.desserts[i.index_of + 1].porcentagem_1 = i.porcentagem_2;
        this.desserts[i.index_of - 1].porcentagem_2 = i.porcentagem_1;
      }

      const params = {
        dados: this.desserts,
        evento: this.GET_FORM_NOVO_EVENTO
      }

      Api.post(`eventos-sazonais/parametrizacao/configuracao/salvar-porcentagens`, params).catch(this.Helpers.logout)
    },
    aplicarConfiguracaoAntesDoEvento(evt) {
      this.resetBlur(evt);
      Api.post(`eventos-sazonais/parametrizacao/configuracao/aplicar-configuracao-antes-do-evento`, this.config_anterior).catch(this.Helpers.logout)
    },
  }
}
</script>

<style>
.v-input--selection-controls__input {
  margin-right: 10px !important;
}
.test-sazonalidade > .v-input__control > .v-input__slot > .v-text-field__slot > input {
  padding: 0px 5px 0px 0px;
  text-align: end;
}
</style>
